import { SHOWCASE_DEFAULTS } from '@shared/core/website/headerMotion/headerMotion.catalog';
import type { HeaderMotionOptions } from '@shared/core/website/headerMotion/headerMotion.types';
import { motionNamesColor } from '../../multiPhotoMotion.options';

/**
 * Sanitises saved Showcase options: the catalog's `SHOWCASE_DEFAULTS`, plus `namesColor` when the saved
 * one is a plain hex colour (see `motionNamesColor`). Every other key is dropped. Pure; never throws.
 */
export const parseShowcaseOptions = (raw: Readonly<Record<string, unknown>>): HeaderMotionOptions => {
  const namesColor = motionNamesColor(raw);
  return namesColor ? { ...SHOWCASE_DEFAULTS, namesColor } : SHOWCASE_DEFAULTS;
};
